import { primaryColor, grayColor } from "assets/jss/emjayTheme.js";
import {
  blackColor,
  dangerColor,
  successColor,
  whiteColor,
} from "assets/jss/emjayTheme";

const overlayStyle = (theme) => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999,
  },
  container: {
    // width: '80%',
    // height: '80%',
    backgroundColor: whiteColor,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: blackColor,
    padding: 10,
    fontSize: "1.1rem",
  },
  spinner: {
    color: primaryColor[2],
  },
  success: {
    color: successColor[1],
  },
  error: {
    color: dangerColor[4],
  },
  item: {
    margin: "5px 0",
    textAlign: 'center',
  },
});

export default overlayStyle;
